"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.DesktopOnly = exports.TabletUp = exports.TabletDown = exports.MobileOnly = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var ResponsiveDisplay = _styledComponents["default"].div.withConfig({
  displayName: "ResponsiveDisplay",
  componentId: "sc-1f0onej-0"
})(["", " ", " ", ""], _styledSystem.width, _styledSystem.space, _styledSystem.height);

ResponsiveDisplay.propTypes = (0, _extends2["default"])({
  visibleAs: _propTypes["default"].string
}, _styledSystem.width.propTypes, {}, _styledSystem.space.propTypes, {}, _styledSystem.height.propTypes);
ResponsiveDisplay.defaultProps = {
  visibleAs: "block",
  width: "auto"
};
var MobileOnly = (0, _styledComponents["default"])(ResponsiveDisplay).withConfig({
  displayName: "ResponsiveDisplay__MobileOnly",
  componentId: "sc-1f0onej-1"
})(["@media only screen and (max-width:", "px){display:", ";}@media only screen and (min-width:", "px){display:none;overflow:hidden;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints[0] - 1;
}, function (_ref2) {
  var visibleAs = _ref2.visibleAs;
  return visibleAs;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints[0];
});
exports.MobileOnly = MobileOnly;
var TabletDown = (0, _styledComponents["default"])(ResponsiveDisplay).withConfig({
  displayName: "ResponsiveDisplay__TabletDown",
  componentId: "sc-1f0onej-2"
})(["@media only screen and (max-width:", "px){display:", ";}@media only screen and (min-width:", "px){display:none;overflow:hidden;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints[1] - 1;
}, function (_ref5) {
  var visibleAs = _ref5.visibleAs;
  return visibleAs;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints[1];
});
exports.TabletDown = TabletDown;
var TabletUp = (0, _styledComponents["default"])(ResponsiveDisplay).withConfig({
  displayName: "ResponsiveDisplay__TabletUp",
  componentId: "sc-1f0onej-3"
})(["@media only screen and (max-width:", "px){display:none;overflow:hidden;}@media only screen and (min-width:", "px){display:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints[0] - 1;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints[0];
}, function (_ref9) {
  var visibleAs = _ref9.visibleAs;
  return visibleAs;
});
exports.TabletUp = TabletUp;
var DesktopOnly = (0, _styledComponents["default"])(ResponsiveDisplay).withConfig({
  displayName: "ResponsiveDisplay__DesktopOnly",
  componentId: "sc-1f0onej-4"
})(["@media only screen and (max-width:", "px){display:none;overflow:hidden;}@media only screen and (min-width:", "px){display:", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints[1] - 1;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints[1];
}, function (_ref12) {
  var visibleAs = _ref12.visibleAs;
  return visibleAs;
});
exports.DesktopOnly = DesktopOnly;